export { ErrorPage as default, ErrorPage } from "@sw-business-solutions/cst-mobikart-ui/shared"
export * from "@sw-business-solutions/cst-mobikart-ui/shared"